module.exports = __webpack_public_path__ + "img/coach-intro-program.fd681f01.svg";